import { type FC } from 'react'

import { PimVariantAttributeV1TypeEnum } from '@redteclab/api/clients/bully'

import { type SelectionEntry } from '../../../product-page-context/AttributeGroup'
import { ProductPageColorTypeAttributePreview } from '../ProductPageColorTypeAttributeGroup/ProductPageColorTypeAttributePreview'

export const ProductAttributeTileWithPriceDescription: FC<{
  selectionEntry: SelectionEntry
}> = ({ selectionEntry }) => {
  const { attribute } = selectionEntry
  const isColorVariant = attribute.type === PimVariantAttributeV1TypeEnum.Color

  if (!attribute.value) {
    return null
  }

  if (isColorVariant) {
    return (
      <span className="inline-block w-full truncate text-center align-middle text-s tablet:text-left">
        {attribute.hex ? (
          <ProductPageColorTypeAttributePreview
            selectionEntry={selectionEntry}
          />
        ) : null}
        <span className="align-middle">{attribute.value}</span>
      </span>
    )
  }

  return (
    <span
      className="inline-block w-full truncate align-middle"
      title={attribute.value}
    >
      {attribute.value}
    </span>
  )
}
